import { deleteRequest, getRequest, postRequest } from "../utils/fetch";

const basePath = "/ApiCore/WishlistApi";

export interface IWishlistItem {
	productCategoryCode?: string;
	predefinedProductNameAndPvc?: string;
	theme?: string;
}

export async function getWishlistItems(): Promise<IWishlistItem[]> {
	const res = await getRequest(basePath + "/GetWishListItems", {
		headers: { "Content-type": "application/json; charset=utf-8" },
	});
	return res as IWishlistItem[];
}

export async function addWishlistItem(
	productCategoryCode: string,
	predefinedProductNameAndPvc: string,
	theme: string,
): Promise<IWishlistItem> {
	const res = await postRequest(
		basePath + "/AddWishListItem",
		{ productCategoryCode, predefinedProductNameAndPvc, theme },
		{ headers: { "Content-type": "application/json; charset=utf-8" } },
	);
	return res as IWishlistItem;
}

export function deleteWishlistItem(productCategoryCode: string, predefinedProductNameAndPvc: string): Promise<void> {
	return deleteRequest(
		basePath + "/DeleteWishListItem",
		{ productCategoryCode, predefinedProductNameAndPvc },
		{ headers: { "Content-type": "application/json; charset=utf-8" } },
	);
}
